import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from './router'


Vue.config.productionTip = false;

// https://stackoverflow.com/questions/44371639/how-to-remove-html-tags-from-rendered-text
Vue.filter('striphtml', function (value) {
  var div = document.createElement("div");
  div.innerHTML = value;
  var text = div.textContent || div.innerText || "";
  return text;
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#filter-app");
